'use client';

import { PublicPageLayout } from '@letsgo/PublicPageLayout';
import Link from 'next/link';
import { Box, Container, Typography, Button } from '@mui/material';

export default function CommunityPage() {
  return (
    <PublicPageLayout>
      <Container maxWidth="md" sx={{ py: 8, textAlign: 'center' }}>
        <Typography variant="h4" component="h1" fontWeight={700} mb={2} color="text.primary">
          Community
        </Typography>
        <Typography variant="body1" color="text.primary" mb={2}>
          A dedicated community space for FloAI users is coming soon. Connect with other creators, share tips, and get early access when we launch.
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={4}>
          Want to be notified when we launch? Contact us and mention &quot;Community&quot; in your message.
        </Typography>
        <Button component={Link} href="/contact" variant="contained" color="primary" size="large">
          Contact us to join early
        </Button>
      </Container>
    </PublicPageLayout>
  );
}
